<script setup>
import { onMounted, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useUserStateStore } from '@/stores/userState'

const userStateStore = useUserStateStore()
const { stateItems, currentState } = storeToRefs(userStateStore)
const isLoading = ref(true) // ToDo: Skeleton loader

const handleChangeState = async (newState) => {
  await userStateStore.changeState(newState)
}

onMounted(() => {
  userStateStore
    .fetchStateItems()
    .then(() => userStateStore.fetchCurrentState())
    .finally(() => isLoading.value = false)
})
</script>

<template>
  <v-menu offset="20">
    <template v-slot:activator="{ props }">
      <!-- <v-skeleton-loader
        v-if="isLoading"
        elevation="12"
        boilerplate
        type="list-item-avatar"
        class="status-btn"
      ></v-skeleton-loader>
      <div v-else v-bind="props" plain class="status-btn"> -->
      <div v-bind="props" plain class="status-btn">
        <v-icon :style="{ color: currentState.color }" class="">mdi-circle</v-icon>
        <div>
          <span class="mr-2">{{ currentState.label }}</span>
          <v-icon>mdi-menu-down</v-icon>
        </div>
      </div>
    </template>
    <v-list density="compact">
      <v-list-item v-for="item in stateItems" :key="item.id" :value="item.id" @click="handleChangeState(item)">
        <v-list-item-title>{{ item.label }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<style lang="scss" scoped>

.drawer-header {
  background-color: rgb(var(--v-theme-brandPrimary));
  padding: 16px 16px;
}

.menu {
  background-color: rgba(var(--v-theme-brandGray), 0.8);
}

.v-menu>.v-overlay__content>.v-list {
  background-color: rgb(var(--v-theme-brandLight));
}

.status-btn {
  min-width: 167px;
  display: flex;
  justify-content: space-between;
  // gap: 10px; // option2: if min-width is not fixed
}

.status-btn:hover {
  cursor: pointer;
  opacity: 0.8;
}
</style>
